import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Drawer from '@mui/material/Drawer';

export default class RequestTest extends Component {
    render() {
        return (
            <div>
                {
                    window.innerWidth < 767 ?
                        ['bottom'].map((anchor) => (
                            <React.Fragment key={anchor}>
                                <Drawer
                                    anchor={anchor}
                                    open={this.props.isRequest}
                                    className='confirm-modal1'
                                >
                                    <div className="p-3 text-center">
                                        <img src='/images/student.svg' alt='' />
                                        <h1 style={{ fontSize: 20 }}>
                                            This test is not activated for your account. This test will be activated within two weeks after confirmation from your admin. Are you sure you want to take this skill test ?</h1>
                                        <div className="text-center d-flex flex-column align-items-center p-2 ">
                                            <p className="text-capitalize">{this.props.skill}</p>
                                        </div>
                                        <div className="save-btn">
                                            <button onClick={this.props.requestConfirm}>Yes</button> &nbsp;&nbsp;
                                            <button onClick={this.props.handleIntroModalClose}>No</button>
                                        </div>
                                    </div>
                                </Drawer>
                            </React.Fragment>
                        ))
                        :
                        < Modal
                            show={this.props.isRequest}
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            // onHide={this.handleCloseModal}
                            dialogClassName={"confirm-modal1"}
                        >
                            <div className="p-3 text-center">
                                <img src='/images/student.svg' alt='' />
                                <h1 style={{ fontSize: 16 }}>
                                    This test is not activated for your account. This test will be activated within two weeks after confirmation from your admin. Are you sure you want to take this skill test ?</h1>
                                <div className="text-center d-flex flex-column align-items-center p-2 ">
                                    <p className="text-capitalize">{this.props.skill}</p>
                                </div>
                                <div className="save-btn">
                                    <button onClick={this.props.requestConfirm}>Yes</button> &nbsp;&nbsp;
                                    <button onClick={this.props.handleIntroModalClose}>No</button>
                                </div>
                            </div>
                        </Modal>

                }
            </div>
        )
    }
}
